(() => {
  const source = document.getElementById('ClarkStorefrontStrings');
  if (!source) return;
  let labels;
  try { labels = JSON.parse(source.textContent); } catch { return; }
  let pending = false;
  function update() {
    pending = false;
    if (document.querySelector('[data-clark-product-details]')) {
      document.querySelectorAll('.product__info-wrapper .rfq-btn').forEach(button => {
        if (button.textContent.trim() !== labels.add) button.textContent = labels.add;
        if (button.getAttribute('aria-label') !== labels.add) button.setAttribute('aria-label', labels.add);
      });
    }
    const list = document.getElementById('grfq-page');
    if (!list) return;
    const messageHeading = list.querySelector('#grfq-quote_form_custom_4-collapsible');
    if (messageHeading && messageHeading.textContent.trim() === 'Elements') messageHeading.textContent = labels.message;
    list.querySelectorAll('h3,button').forEach(element => {
      if (element.textContent.trim() === 'I Want This Item') element.textContent = labels.send;
    });
    const contact = list.querySelector('#grfq-contact_info');
    if (contact && labels.privacyUrl && !list.querySelector('[data-clark-quote-privacy]')) {
      const note = document.createElement('p');
      note.className = 'clark-quote-privacy';
      note.setAttribute('data-clark-quote-privacy', '');
      const link = document.createElement('a');
      link.href = labels.privacyUrl;
      link.textContent = labels.privacy;
      note.append(link);
      contact.before(note);
    }
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  update();
})();
